import React, { useEffect, useState } from "react";
// import { changeStatusTherapist, deleteTherapist, getTherapists } from "../../../../api/therapist";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Table, { buttonsStyle } from "../../../components/tables/table";
import { Button, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ToggleOffIcon from "@material-ui/icons/ToggleOff";
import ToggleOnIcon from "@material-ui/icons/ToggleOn";
import DeleteIcon from "@material-ui/icons/Delete";
import CalendarToday from "@material-ui/icons/CalendarToday";
import EmailIcon from "@material-ui/icons/Email";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../_metronic/_partials/controls";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { changeStatusUser, deleteUser, getUsers, sendVerifyUserMailAndRefresh } from "../../../../api/user";
import { grantPermissionsCalendar } from "../../../../api/calendar";
import { therapistIsVerified } from "../../../../utils/auth";
import {
  isGoogleCalendarTokenExpiredError,
  promptReconnectGoogleCalendar,
} from "../../../../utils/googleCalendarAuth";

export default function TherapistPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);
    const [therapists, setTherapists] = useState([]);
    const [therapist, setTherapist] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        setRefresh(false);
    }, [refresh])

    useEffect(() => {
        fetch();
    }, [])

    function fetch() {
        getUsers({ therapists: true })
            .then((res) => {
                setTherapists(res.data);
            })
            .catch((error) => {
                if (error.request.status !== 404) {
                    alertError({
                        error,
                        customMessage: "No se ha podido encontrar el therapists."
                    })
                }
            })
    }

    const columns = [
        { dataField: "fullName", text: "Nombre completo", formatter: nameFormatter, sort: true },
        { dataField: "acronym", text: "Acrónimo", sort: true },
        { dataField: "verified", text: "Verificado", formatter: verifiedFormatter },
        {
            dataField: "_id",
            text: "",
            formatter: buttonFormatter,
            align: 'right',
            headerStyle: { width: '240px' }
        },
    ];

    function verifiedFormatter(cell, row) {
        if (therapistIsVerified(row)) return "Si";
        return "No";
    }

    function nameFormatter(cell, row) {
        return `${cell}${row?.surname ? ` ${row?.surname}` : ""}`
    }

    function buttonFormatter(cell) {
        const elem = therapists.find((item) => item._id === cell);

        return (
        <>
            <Tooltip title="Editar">
            <Button
                style={buttonsStyle}
                size="small"
                onClick={() => history.push("/edit-therapist/" + elem._id)}
            >
                <EditIcon />
            </Button>
            </Tooltip>
            {user?.isAdmin && (
            <>
                <Tooltip title={elem?.active ? "Desactivar" : "Activar"}>
                <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                        setTherapist(elem);
                        setOpenConfirmDialog(1);
                    }}
                >
                    {elem?.active ? (
                    <ToggleOffIcon />
                    ) : (
                    <ToggleOnIcon style={{ color: "red" }} />
                    )}
                </Button>
                </Tooltip>
                <Tooltip title="Borrar">
                <Button
                    style={buttonsStyle}
                    size="small"
                    onClick={() => {
                        setTherapist(elem);
                        setOpenConfirmDialog(2);
                    }}
                >
                    <DeleteIcon />
                </Button>
                </Tooltip>

                { !elem?.password && (
                    <Tooltip title="Mail verificación">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            setTherapist(elem);
                            setOpenConfirmDialog(4)
                        }}
                    >
                        <EmailIcon />
                    </Button>
                    </Tooltip>
                )}

                { !elem?.calendarId && (
                    <Tooltip title="Mail calendar">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => {
                            setTherapist(elem);
                            setOpenConfirmDialog(3)
                        }}
                    >
                        <CalendarToday />
                    </Button>
                    </Tooltip>
                )}
                </>
            )}
        </>
        );
    }

    return  (
        <Card>
            <CardHeader title="Terapeutas">
                <CardHeaderToolbar>
                {user?.isAdmin && (
                    <button
                        type="button"
                        className="btn btn-light-primary font-weight-bold mr-2"
                        onClick={() => history.push("/calendar?refresh=true")}
                    >
                        Reconectar Google Calendar
                    </button>
                )}
                <button
                    type="button"
                    className="btn btn-primary text-white"
                    onClick={() => history.push("/edit-therapist")}
                >
                    Añadir
                </button>
                </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
                { !refresh && (
                    <Table data={therapists} columns={columns} />
                )}
            </CardBody>
            <ConfirmDialog
                title={`Seguro que quieres ${therapist?.active ? 'deshabilitar' : 'habilitar'} el terapeuta?`}
                open={openConfirmDialog === 1}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    changeStatusUser(therapist._id, !therapist?.active)
                        .then((res) => {
                            if (res.status === 200) {
                                alertSuccess({ title: `${therapist?.active ? 'Deshabilitado!' : 'Habilitado!'}`, customMessage: `Admin ${therapist?.active ? 'deshabilitado' : 'habilitado'} correctamente` })
                                fetch();
                                setRefresh(true);
                            }
                        })
                        .catch((error) => {
                            alertError({ error: error, customMessage: `No se ha podido ${therapist?.active ? 'deshabilitar' : 'habilitar'} terapeuta.` })
                        });
                }}
            />
            <ConfirmDialog
                title={'Seguro que quieres eliminar el terapeuta?'}
                open={openConfirmDialog === 2}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    deleteUser(therapist?._id)
                        .then((res) => {
                            if (res.status === 204 || res.status === 200) {
                                alertSuccess({
                                    title: 'Eliminado!',
                                    customMessage: 'Terapeuta eliminado correctamente.',
                                });
                                fetch();
                                setRefresh(true);
                            }
                        })
                        .catch((error) => {
                            alertError({
                                error: error,
                                customMessage: 'No se ha podido eliminar el terapeuta.',
                            });
                        });
                }}
            />
            <ConfirmDialog
                title={'Seguro que quieres enviar el email con la garantización de los permisos para el Calendar compartido al terapueta?'}
                open={openConfirmDialog === 3}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    grantPermissionsCalendar(therapist?._id, therapist?.fullName, therapist?.surname, therapist?.email)
                        .then((res) => {
                            alertSuccess({ message: "Mail enviado correctamente!" });
                        })
                        .catch((error) => {
                            if (isGoogleCalendarTokenExpiredError(error)) {
                                promptReconnectGoogleCalendar(history);
                                return;
                            }
                            alertError({ error, message: "No se ha podido enviar el mail."});
                        })
                }}
            />
            <ConfirmDialog
                title={'Seguro que quieres enviar un mail de verificación al terapeuta?'}
                open={openConfirmDialog === 4}
                setOpen={setOpenConfirmDialog}
                onConfirm={() => {
                    sendVerifyUserMailAndRefresh(therapist?.verificationToken)
                        .then((res) => {
                            alertSuccess({ title: "Éxito!", customMessage: "Mail enviado correctamente." });
                            fetch();
                        })
                        .catch((error) => {
                            alertError({ error, customMessage: "No se ha podido enviar el mail." });
                        })
                }}
            />
        </Card>
    )
} 